import { localURLMaker, urlMaker } from '@shared/utils/url-maker'
import { caller } from '@shared/utils/caller'
import { ApiResponse } from '@shared/utils/api-response'
import { ProductCategory, ProductCategoryFormData, ProductCategoryFormDataApi, ProductCategoryFormErrors } from '../types/categories'
import { ProductCategoryMappers } from '../mappers/categories'
import { appendToFormData } from '@shared/utils/apply-to-form-data'
import { NextTableMetaResponse } from '@shared/modules/next-table/types'
import { nextTableMetaMapper } from '@shared/modules/next-table/utils/meta-mapper'
import { formDataFlat } from '@shared/utils/form-data-flat'

export class ProductCategoriesService {
  public static async getAll(
    query?: Record<string, any>,
  ): Promise<ApiResponse<200, ProductCategory[], NextTableMetaResponse> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/product_categories', query)

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data, ...meta } = await response.json()
        return new ApiResponse(200, ProductCategoryMappers.manyFromApi(data), nextTableMetaMapper(meta))
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async getOneById(id: string | number): Promise<ApiResponse<200, ProductCategory> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/product_categories/info', { product_category_id: id })

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data } = await response.json()
        return new ApiResponse(200, ProductCategoryMappers.fromApi(data), null)
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }

  public static async createOrUpdate(
    values: ProductCategoryFormData,
    type: string = 'create',
  ): Promise<ApiResponse<200> | ApiResponse<422, ProductCategoryFormErrors> | ApiResponse<400 | 500, string>> {
    const url = type === 'create' ? urlMaker('/api/product_categories/create') : urlMaker('/api/product_categories/edit')
    const body = new FormData()

    appendToFormData<ProductCategoryFormDataApi>(ProductCategoryMappers.formDataToApi(values), body)

    try {
      const response = await caller(url, { body, method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else if (response.status === 422) {
        const { errors } = await response.json()

        return new ApiResponse(422, ProductCategoryMappers.formErrorsFromApi(errors), null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }

  public static async actionByIds(ids: (string | number)[], action: string): Promise<ApiResponse<200> | ApiResponse<400 | 500, string>> {
    const url = urlMaker(localURLMaker('/api/product_categories/:action', { action }))
    const body = new FormData()

    appendToFormData(formDataFlat({ product_category_id: ids }), body)

    try {
      const response = await caller(url, { method: 'POST', body })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }
}
